
export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    position: 'Spa Owner',
    company: 'Serenity Spa & Wellness',
    rating: 5,
    review: 'Manohar International has been our trusted supplier for over 3 years. Their product quality is exceptional, and their customer service is outstanding. The massage tables and spa equipment we purchased have exceeded our expectations.',
    avatar: 'https://public.readdy.ai/ai/img_res/8c7c8181157fb2a896ee3516372b591e.jpg'
  },
  {
    id: 2,
    name: 'Rajesh Kumar',
    position: 'Salon Manager',
    company: 'Elite Hair Studio',
    rating: 5,
    review: 'The salon equipment from Manohar International is top-notch. We recently upgraded our entire salon with their styling stations and chairs. Our clients love the comfort, and the quality is unmatched. Highly recommended!',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20indian%20man%20salon%20manager%20confident%20smile%20business%20portrait%20clean%20white%20background%20professional%20photography&width=200&height=200&seq=test2&orientation=squarish'
  },
  {
    id: 3,
    name: 'Dr. Anjali Mehta',
    position: 'Dermatologist',
    company: 'Skin Care Clinic',
    rating: 5,
    review: 'As a medical professional, I need reliable equipment. Manohar International provides medical-grade products that meet all safety standards. Their LED therapy devices and microdermabrasion machines are excellent.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20indian%20female%20doctor%20dermatologist%20confident%20smile%20white%20coat%20business%20portrait%20clean%20white%20background%20professional%20photography&width=200&height=200&seq=test3&orientation=squarish'
  },
  {
    id: 4,
    name: 'Vikram Patel',
    position: 'Wellness Center Director',
    company: 'Harmony Wellness',
    rating: 5,
    review: 'Outstanding products and service! We equipped our entire wellness center with products from Manohar International. The quality-to-price ratio is incredible, and their after-sales support is remarkable.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20indian%20man%20wellness%20director%20confident%20business%20portrait%20clean%20white%20background%20professional%20photography&width=200&height=200&seq=test4&orientation=squarish'
  },
  {
    id: 5,
    name: 'Neha Desai',
    position: 'Beauty Salon Owner',
    company: 'Glamour Beauty Lounge',
    rating: 5,
    review: 'I have been purchasing from Manohar International for my salon for the past 2 years. Their product range is comprehensive, and the quality is consistently excellent. They truly understand the beauty industry needs.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20indian%20woman%20beauty%20salon%20owner%20elegant%20smile%20business%20portrait%20clean%20white%20background%20professional%20photography&width=200&height=200&seq=test5&orientation=squarish'
  },
  {
    id: 6,
    name: 'Arjun Singh',
    position: 'Spa Consultant',
    company: 'Luxury Spa Solutions',
    rating: 5,
    review: 'As a spa consultant, I recommend Manohar International to all my clients. Their products are reliable, durable, and competitively priced. The team is knowledgeable and always ready to help with product selection.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20indian%20man%20spa%20consultant%20confident%20business%20portrait%20clean%20white%20background%20professional%20photography&width=200&height=200&seq=test6&orientation=squarish'
  }
];
